interface ProcessSectionProps {
  onOpenAuditModal: () => void;
}

export default function ProcessSection({ onOpenAuditModal }: ProcessSectionProps) {
  const steps = [
    {
      number: '01',
      title: 'Audit gratuit',
      description: 'Analyse de vos besoins, évaluation de votre portefeuille client, définition du périmètre de collaboration.',
      duration: '1-2 jours'
    },
    {
      number: '02',
      title: 'Proposition personnalisée',
      description: 'Devis détaillé, planning de transition, présentation de l\'équipe dédiée et des outils utilisés.',
      duration: '2-3 jours'
    },
    {
      number: '03',
      title: 'Phase de test',
      description: 'Traitement d\'un échantillon de dossiers pour valider la qualité et les processus.',
      duration: '1 semaine'
    },
    {
      number: '04',
      title: 'Transition progressive',
      description: 'Transfert progressif des dossiers, formation des équipes, mise en place des procédures.',
      duration: '2-4 semaines'
    },
    {
      number: '05',
      title: 'Suivi et optimisation',
      description: 'Monitoring permanent de la qualité, reporting hebdomadaire, ajustements continus.',
      duration: 'En continu'
    }
  ];

  return (
    <section id="processus" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Notre processus de collaboration
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une approche structurée et progressive pour garantir le succès de notre partenariat.
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-px h-full w-0.5 bg-blue-200"></div>

          <div className="space-y-12">
            {steps.map((step, index) => (
              <div key={index} className={`flex flex-col lg:flex-row items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                  <div className="bg-white rounded-xl p-8 shadow-lg">
                    <div className="flex items-center mb-4">
                      <span className="text-3xl font-bold text-blue-900 mr-4">
                        {step.number}
                      </span>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">
                          {step.title}
                        </h3>
                        <span className="text-sm text-blue-600 font-medium">
                          {step.duration}
                        </span>
                      </div>
                    </div>
                    <p className="text-gray-600">
                      {step.description}
                    </p>
                  </div>
                </div>

                <div className="hidden lg:flex w-2/12 justify-center">
                  <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold">
                      {step.number}
                    </span>
                  </div>
                </div>

                <div className="w-full lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <button 
            onClick={onOpenAuditModal}
            className="bg-blue-900 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Commencer l'audit gratuit
          </button>
        </div>
      </div>
    </section>
  );
}